import { render, staticRenderFns } from "./BackupVPS.vue?vue&type=template&id=450229e5"
import script from "./BackupVPS.vue?vue&type=script&lang=js"
export * from "./BackupVPS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports